// extracted by mini-css-extract-plugin
export var active = "_2p-9";
export var backButton = "_2p-8";
export var clone = "_2p-e";
export var collapseBar = "_2p-j";
export var collapseMode = "_2p-l";
export var collapsed = "_2p-n";
export var dragHandle = "_2p-c";
export var dropdownIcon = "_2p-g";
export var expanding = "_2p-m";
export var hidden = "_2p-w";
export var iconContainer = "_2p-p";
export var iconSwapper = "_2p-v";
export var navItem = "_2p-6";
export var navItemIcon = "_2p-f";
export var navProfile = "_2p-7";
export var notificationCountBadge = "_2p-i";
export var notificationDot = "_2p-q";
export var optionsContainer = "_2p-h";
export var primaryNav = "_2p-0";
export var primaryNavDivider = "_2p-u";
export var primaryNavResizeHandle = "_2p-2";
export var primaryNavResizing = "_2p-1";
export var primaryNavTabSection = "_2p-t";
export var primaryTab = "_2p-o";
export var primaryTabIconBox = "_2p-r";
export var secondaryNav = "_2p-3";
export var selected = "_2p-s";
export var settingsNav = "_2p-4";
export var settingsNavItems = "_2p-5";
export var show = "_2p-d";
export var sideNav = "_2p-k";
export var teamItem = "_2p-a";
export var userProfileItem = "_2p-b";